module.exports = __webpack_public_path__ + "static/media/3.38f78bb4.jpg";